module.exports = __webpack_public_path__ + "img/my_location-24px.1550246b.svg";